import { defineStore } from 'pinia';
import { ref } from 'vue';

import type { FooterData } from '@/pages/footer-fi/FooterFi.vue';
import lowerCaseKeys from '@/utils/lowerCaseKeys';

export const useLayoutStore = defineStore('useLayoutStore', () => {
  const pageId = ref<string | null>(null);
  const headerData = ref<Record<string, any>>({});
  const footerData = ref<FooterData | undefined>();
  const productDetailHeadMounted = ref(false);
  const headerHeight = ref(0);
  const windowDimensions = ref({ width: 0, height: 0 });
  const windowScrollPos = ref({ x: 0, y: 0 });

  const setLayoutData = (layoutData: any) => {
    footerData.value = lowerCaseKeys(layoutData.Footer, true);
    headerData.value = lowerCaseKeys(
      {
        breadcrumb: layoutData.Breadcrumb,
        logoBrandArea: layoutData.LogoBrandArea,
        logoHeader: layoutData.LogoHeader,
        navigation: layoutData.Navigation,
        serviceNavigation: layoutData.ServiceNavigation,
      },
      true,
    );
  };

  const updateHeaderData = (data: Record<string, any>) => {
    headerData.value = { ...headerData.value, ...data };
  };

  const setProductDetailHeadMounted = (value: boolean) => {
    productDetailHeadMounted.value = value;
  };

  const setHeaderHeight = (value: number) => {
    headerHeight.value = value;
  };

  const setWindowDimensions = (value: { width: number; height: number }) => {
    windowDimensions.value = value;
  };

  const setWindowScrollPos = (value: { x: number; y: number }) => {
    windowScrollPos.value = value;
  };

  return {
    pageId,
    headerData,
    footerData,
    productDetailHeadMounted,
    headerHeight,
    windowDimensions,
    windowScrollPos,
    setLayoutData,
    updateHeaderData,
    setProductDetailHeadMounted,
    setHeaderHeight,
    setWindowDimensions,
    setWindowScrollPos,
  };
});
